import { useComponentRegistry } from '@bem-react/di';

import { IRegistry } from 'client/platforms/desktop';

export function useComponents() {
    return useComponentRegistry<IRegistry>('app');
}
